//todo: save these as .svg, no need for react components here
export function TrailerIcon() {
  return (
    <svg width='13' height='12' viewBox='0 0 13 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.03925 2.2998H5.61859L5.34564 2.62012H1.30829C1.05902 2.62061 0.857117 4.01514 0.857117 5.57764C0.857117 7.13965 1.05902 8.40625 1.30829 8.40674H12.3657C12.6149 8.40625 12.8168 7.13965 12.8168 5.57764C12.8168 4.01514 12.6149 2.62061 12.3657 2.62012H8.31219L8.03925 2.2998Z'
        fill='currentColor'
      />
      <path
        d='M12.8168 9.66699V8.854H0.857117V9.76514H1.14834H1.27118H4.05072L4.75824 10.2578H7.71234C7.86224 9.72412 8.35272 9.33252 8.93427 9.33252C9.51605 9.33252 10.0063 9.72412 10.1562 10.2578H10.7365C10.8862 9.72412 11.3766 9.33252 11.9582 9.33252C12.2895 9.33252 12.591 9.45947 12.8168 9.66699Z'
        fill='currentColor'
      />
      <path
        d='M8.93427 11.5C9.4306 11.5 9.83319 11.0977 9.83319 10.6016C9.83319 10.105 9.4306 9.70264 8.93427 9.70264C8.43793 9.70264 8.03558 10.105 8.03558 10.6016C8.03558 11.0977 8.43793 11.5 8.93427 11.5Z'
        fill='currentColor'
      />
      <path
        d='M12.8571 10.6016C12.8571 11.0977 12.4548 11.5 11.9582 11.5C11.4619 11.5 11.0595 11.0977 11.0595 10.6016C11.0595 10.105 11.4619 9.70264 11.9582 9.70264C12.4548 9.70264 12.8571 10.105 12.8571 10.6016Z'
        fill='currentColor'
      />
    </svg>
  )
}
export function TractorIcon() {
  return (
    <svg width='13' height='12' viewBox='0 0 13 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2923 2.00898L10.8348 1.79297V9.34746H12.5167C11.8506 9.49312 11.3416 10.0596 11.2826 10.7543H5.67929C5.61058 9.94585 4.93246 9.31097 4.10622 9.31097C3.27999 9.31097 2.60187 9.94585 2.53315 10.7543H0.571289L0.659732 9.34746H0.949228L1.63737 6.90393L4.4738 6.39432L5.95186 4.06159H7.09093L8.20732 3.44084C8.60778 3.21792 9.05822 3.1012 9.51638 3.1012H10.2923V2.00898ZM6.42235 4.73198L5.34739 6.46895H8.749V4.73198H6.42235Z'
        fill='currentColor'
      />
      <path
        d='M5.21561 10.8898C5.21561 11.5025 4.71894 11.9992 4.10626 11.9992C3.49358 11.9992 2.9969 11.5025 2.9969 10.8898C2.9969 10.2772 3.49358 9.78047 4.10626 9.78047C4.71894 9.78047 5.21561 10.2772 5.21561 10.8898Z'
        fill='currentColor'
      />
      <path
        d='M11.7464 10.8898C11.7464 10.3755 12.0964 9.94288 12.5713 9.81728V11.9624C12.0964 11.8368 11.7464 11.4042 11.7464 10.8898Z'
        fill='currentColor'
      />
    </svg>
  )
}
